import React from 'react'
import icon_neutral from "../../assets/images/icon-neutral.svg";
import icon_positive from "../../assets/images/icon-positive.svg";
import icon_negative from "../../assets/images/icon-negative.svg";
import styles from "../../assets/styles/modules/RatingIndicator.module.css";


const RatingIndicator = ({signal, percent}) => {
    if (signal === "긍정") {
        return (
            <div className={`${styles.rating_indicator} ${styles.positive}`}>
                <img src={icon_positive} alt="positive rating icon" className={styles.rating_icon}/>
                <p>{!!percent ? percent : 0}%</p>
            </div>
        );
    }

    if (signal === "부정") {
        return (
            <div className={`${styles.rating_indicator} ${styles.negative}`}>
                <img src={icon_negative} alt="negative rating icon" className={styles.rating_icon}/>
                <p>{!!percent ? percent : 0}%</p>

            </div>
        );
    }
    if (signal === "중립") {
        return (
            <div className={`${styles.rating_indicator} ${styles.neutral}`}>
                <img src={icon_neutral} alt="neutral rating icon" className={styles.rating_icon}/>
                <p>{!!percent ? percent : 0}%</p>
            </div>
        );
    }
}

export default RatingIndicator;